import * as React from 'react';

import PickersDay, { PickersDayProps } from '@mui/lab/PickersDay';
import { styled } from '@mui/material/styles';

type DayProps = PickersDayProps<Date> & {
  current?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  selected?: boolean;
  highlighted?: boolean;
};

export const Day = styled(PickersDay, {
  shouldForwardProp: (prop) =>
    prop !== 'current' &&
    prop !== 'disabled' &&
    prop !== 'hidden' &&
    prop !== 'selected' &&
    prop !== 'highlighted',
})<DayProps>(({ theme, current, disabled, hidden, selected, highlighted }) => ({
  width: theme.spacing(4.5),
  height: theme.spacing(4.5),
  fontSize: theme.typography.caption.fontSize,
  margin: '0 2px',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
  padding: 0,
  ...(current && {
    color: theme.palette.primary.main,
    fontWeight: 600,
  }),
  ...(disabled && {
    pointerEvents: 'none',
    color: theme.palette.text.secondary,
  }),
  ...(hidden && {
    opacity: 0,
    pointerEvents: 'none',
  }),
  ...(selected && {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  }),
  ...(highlighted && {
    backgroundColor: theme.palette.colors.neutral200,
    color: theme.palette.primary.main,
  }),
})) as React.ComponentType<DayProps>;
